import type { FC } from 'react'
import { useMemo } from 'react'
import type { GetStaticProps, InferGetStaticPropsType } from 'next'

import IndustryStartupsView from 'views/Industry/StartupsPage'
import { filterEntries } from 'views/Industry/StartupsPage/data'
import type { StartupsProps } from 'views/Industry/StartupsPage/IndustryStartups'

import { createClient } from '@segment/api/staticSiteBackend/client'

import { createStaticSiteBackend, StaticSiteBackendProvider } from '@segment/contexts/staticSiteBackend'

const Startups: FC<InferGetStaticPropsType<typeof getStaticProps>> = ({ data }) => {
  const staticSiteBackend = useMemo(() => createStaticSiteBackend(), [])
  return (
    <StaticSiteBackendProvider value={staticSiteBackend}>
      <IndustryStartupsView data={data} />
    </StaticSiteBackendProvider>
  )
}

export const getStaticProps: GetStaticProps<StartupsProps> = async () => {
  const client = createClient()
  const data = await filterEntries(client)

  const props = {
    data,
  }

  return {
    props,
  }
}

export default Startups
